module.exports = __webpack_public_path__ + "img/close.5a51797f.svg";